// extracted by mini-css-extract-plugin
export default {"tilesContainer":"overviewStyles_tilesContainer__glWix"};